module.exports = __webpack_public_path__ + "img/occurence-baisse.db384e26.svg";